import { render } from "./LoginPage.vue?vue&type=template&id=bdb82d14&scoped=true&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=bdb82d14&scoped=true&lang=css"

import exportComponent from "/Users/pablo/Sites/buen-provecho-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb82d14"]])

export default __exports__